<template>
  <el-container v-loading="loading">
    <el-header class="icon-header">
      <SiteName />
      <div class="header-button">
        <el-button type="text" class="header-button-text">已有账号？</el-button>
        <el-button size="mini" plain round @click="$router.push({name: 'login'})">登录</el-button>
      </div>
    </el-header>
    <div class="box">
      <div class="content-title">
        <span>只需三步即可投放广告! 开户咨询 : 400-XXX-XXXX</span>
      </div>
      <div class="content-steps">
        <el-steps :active="stepActive" finish-status="success" align-center>
          <el-step class="content-step" title="手机注册"></el-step>
          <el-step class="content-step" title="填写基本信息"></el-step>
          <el-step class="content-step" title="补全广告资质"></el-step>
        </el-steps>
      </div>
      <!-- 填写基本信息 -->
      <div v-show="stepActive === 0">
        <div class="account-form--wrapper">
          <el-form
            ref="basicForm"
            class="demo-ruleForm"
            label-position="left"
            label-width="96px"
            :model="basicForm"
            :rules="basicFormRules"
            :hide-required-asterisk="true"
          >
            <el-form-item prop="phone" label="手机号">
              <el-input
                v-noSpace
                v-model="basicForm.phone"
                placeholder="请输入手机号"
                class="demo-ruleForm-input"
                maxlength="11"
              ></el-input>
            </el-form-item>
            <el-form-item prop="code" label="验证码">
              <div class="demo-ruleForm-box">
                <el-input
                  v-model="basicForm.code"
                  class="demo-ruleForm-input-code"
                  maxlength="4"
                  placeholder="请输入验证码"
                ></el-input>
                <div class="third-item--less">
                  <div class="pic-code--wrapper" @click="updateValicode">
                    <img :src="codePicUrl" />
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="phoneCode" label="短信验证码">
              <div class="demo-ruleForm-box">
                <el-input
                  v-noSpace
                  v-model="basicForm.phoneCode"
                  placeholder="请输入短信验证码"
                  class="demo-ruleForm-input-code"
                ></el-input>
                <div class="third-item--less">
                  <el-button
                    plain
                    :disabled="phoneMsgDisabled"
                    @click="genInteractionCodeMethods(phoneCode, 'phone')"
                  >{{phoneCode.msg}}</el-button>
                </div>
              </div>
            </el-form-item>
            <!-- <el-form-item prop="acceptChecked">
              <el-checkbox v-model="basicForm.acceptChecked"></el-checkbox>&nbsp;
              <span style="color:rgba(0,0,0,0.65)">已阅读并同意</span>
              <a
                style="color: #169BD5;text-decoration:none"
                target="_blank"
                href="/"
                id="serviceAgreement"
              >《酷开推广服务协议》</a>
              <a
                style="color: #169BD5;text-decoration:none"
                target="_blank"
                href="/"
                id="serviceAgreement"
              >《广告主承诺函》</a>
            </el-form-item> -->
            <el-form-item>
              <el-button
                class="demo-ruleForm-btn"
                type="primary"
                :disabled="nextBtnDisabled"
                @click="handleClickFirstNext('basicForm')"
              >下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 获取账号密码 -->
      <div v-show="stepActive === 1">
        <div class="account-form--wrapper">
          <el-form
            ref="accountForm"
            class="demo-ruleForm"
            label-position="left"
            label-width="96px"
            :model="accountForm"
            :hide-required-asterisk="true"
            :rules="accountFormRules"
          >
            <el-form-item label="公司名称" prop="partnerName">
              <el-input
                v-noSpace
                v-model="accountForm.partnerName"
                placeholder="请与营业执照保持一致"
                class="demo-ruleForm-input"
                maxlength="45"
              />
            </el-form-item>
            <el-form-item label="联系人姓名" prop="contact">
              <el-input
                v-noSpace
                v-model="accountForm.contact"
                placeholder="请输入您的姓名"
                class="demo-ruleForm-input"
                maxlength="45"
              />
            </el-form-item>
            <el-form-item label="选择行业">
              <div class="demo-ruleForm-box">
                <el-form-item prop="firstIndustry">
                  <el-select
                    v-model="accountForm.firstIndustry"
                    placeholder="一级行业"
                    class="demo-ruleForm-half-select"
                  >
                    <el-option label="3C及电器" value="1"></el-option>
                    <el-option label="快速消费品" value="2"></el-option>
                    <el-option label="食品饮料" value="3"></el-option>
                    <el-option label="服装配饰" value="4"></el-option>
                    <el-option label="医疗" value="5"></el-option>
                    <el-option label="商务服务" value="6"></el-option>
                    <el-option label="生活服务" value="7"></el-option>
                    <el-option label="房地产" value="8"></el-option>
                    <el-option label="家居建材" value="9"></el-option>
                    <el-option label="教育培训" value="10"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="secondIndustry">
                  <el-select
                    v-model="accountForm.secondIndustry"
                    placeholder="二级行业"
                    class="demo-ruleForm-half-select"
                  >
                    <el-option label="日化用品" value="1"></el-option>
                    <el-option label="一般化妆品" value="2"></el-option>
                    <el-option label="高档化妆品" value="3"></el-option>
                    <el-option label="特殊化妆品" value="4"></el-option>
                    <el-option label="酒" value="5"></el-option>
                    <el-option label="烟" value="6"></el-option>
                    <el-option label="成人用品" value="7"></el-option>
                    <el-option label="宠物用品" value="8"></el-option>
                    <el-option label="母婴用品" value="9"></el-option>
                    <el-option label="其他快速消费品" value="10"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="登录密码" prop="password">
              <el-input
                v-noSpace
                type="password"
                v-model="accountForm.password"
                placeholder="必须包含数字、字母及特殊符号，长度不少于8位"
                class="demo-ruleForm-input"
                maxlength="45"
              />
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input
                v-noSpace
                type="password"
                v-model="accountForm.confirmPassword"
                placeholder="确保和上述密码一致"
                @paste.native.capture.prevent
                class="demo-ruleForm-input"
                maxlength="45"
              />
            </el-form-item>
            <el-form-item>
              <div class="demo-ruleForm-box">
                   <div class="demo-ruleForm-btn">
                  <el-button type="primary" :disabled="nexbtnDisabled"  @click="handleSaveInfo('accountForm',1)">下一步</el-button>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 补全广告资质 -->
      <div v-show="stepActive === 2">
        <div class="account-form--wrapper">
          <el-form
            class="demo-ruleForm"
            label-position="left"
            label-width="96px"
            ref="qualificationForm"
            :model="qualificationForm"
          >
            <el-form-item label="类型">
              <el-radio-group v-model="qualificationForm.registerType">
                <el-radio-button :label="0">企业</el-radio-button>
                <el-radio-button :label="1">个人</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <template v-if="qualificationForm.registerType === 0">
              <el-form-item label="证件类型">
                <div class="demo-ruleForm-box">
                  <el-select
                    v-model="qualificationForm.companyNature"
                    placeholder="请选择"
                    class="demo-ruleForm-half-select"
                  >
                    <el-option label="企业" :value="0"></el-option>
                    <el-option label="个体账户" :value="1"></el-option>
                    <el-option label="政府组织机构/事业单位" :value="2"></el-option>
                    <el-option label="港澳台" :value="3"></el-option>
                    <el-option label="其他机构" :value="4"></el-option>
                    <el-option label="海外" :value="5"></el-option>
                  </el-select>
                  <el-select
                    v-model="qualificationForm.licenseType"
                    placeholder="请选择"
                    class="demo-ruleForm-half-select"
                  >
                    <el-option label="组织机构代码代号" :value="0"></el-option>
                    <el-option label="企业营业执照统一社会信用代码" :value="1"></el-option>
                    <el-option label="企业营业执照注册号" :value="2"></el-option>
                  </el-select>
                </div>
                <div class="remark-tip">优先选择“营业执照统一社会信用代码”；若无则按照实际情况填写</div>
              </el-form-item>
              <el-form-item label="资质照片" class="qualify-item">
                <div class="demo-ruleForm-box">
                  <Upload
                    :uploadUrl="uploadImgUrl"
                    accept=".jpg, .jpeg, .png"
                    class="avatar-uploader"
                    @handleAvatarSuccess="handleLicenseSuccess"
                    :beforeAvatarUpload='handleBeforeAvatarUpload'
                  >
                  <template slot="upload-icon">
                  <img v-if="qualificationForm.license !== ''"
                       :src="qualificationForm.license" class="avatar" />
                       <span v-else>
                          <i class="el-icon-plus avatar-uploader-icon"></i>
                      <div class="text-title">上传图片</div>
                       </span>
                  </template>
                  </Upload>
                  <div class="remark-tip">
                    请上传资质编号清晰可见的相关资质照片。
                    <br />仅持jpg、png、jpeg格式图片，且大小不能大于5M
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="资质编号">
                <el-input
                  v-noSpace
                  v-model="qualificationForm.licenseSn"
                  placeholder="请先选择证件类型，再填写资质编号"
                  class="demo-ruleForm-input"
                />
                <div class="remark-tip">请确保所填资质编号与资质照片上的一致</div>
              </el-form-item>
              <el-form-item label="证件有效期">
                  <div class="demo-ruleForm-box">
                  <el-select v-model="qualificationForm.licenseUsefulLifeType" placeholder="请选择" :class=" qualificationForm.licenseUsefulLifeType === 0 ? 'demo-ruleForm-half-select' : 'demo-ruleForm-select'">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                  <template v-if="qualificationForm.licenseUsefulLifeType ===0">
                <el-date-picker
                  v-model="qualificationForm.licenseUsefulLifeTime"
                   class="demo-ruleForm-half-picker"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
                  </template>
                  </div>
                <div class="remark-tip">请与资质照片上的有效期保持一致，若为长期有效证件请选择“无截止日期”</div>
              </el-form-item>
              <el-form-item label="法人/经营者">
                <el-input
                  v-noSpace
                  v-model="qualificationForm.legalPerson"
                  placeholder="请与照片中的法人/经营者保持一致"
                  class="demo-ruleForm-input"
                  maxlength="45"
                />
              </el-form-item>
              <el-form-item label="法人身份证">
                <div class="demo-ruleForm-box">
                  <Upload
                    :uploadUrl="uploadImgUrl"
                    accept=".jpeg, .png"
                    class="avatar-uploader"
                     @handleAvatarSuccess="handleIdentitySuccess"
                    :beforeAvatarUpload='handleBeforeAvatarUpload'
                  >
                    <template slot="upload-icon">
                      <img  v-if="qualificationForm.identityCardFront !== ''"
                      :src="qualificationForm.identityCardFront" class="avatar" />
                       <span v-else>
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                      <div class="text-title">法人身份证正面</div>
                       </span>
                    </template>
                  </Upload>
                  <Upload
                    :uploadUrl="uploadImgUrl"
                    class="avatar-uploader"
                      accept=".jpeg, .png"
                     @handleAvatarSuccess="handleCardContrarySuccess"
                    :beforeAvatarUpload='handleBeforeAvatarUpload'
                  >
                       <template slot="upload-icon">
                      <img  v-if="qualificationForm.identityCardContrary !== ''"
                      :src="qualificationForm.identityCardContrary" class="avatar" />
                       <span v-else>
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                      <div class="text-title">法人身份证反面</div>
                    </span>
                       </template>
                  </Upload>
                </div>
                <div class="remark-tip">仅支持jpeg、png格式图片，且大小不能超过5M</div>
              </el-form-item>
              <el-form-item label="法人身份证号">
                <el-input
                  v-noSpace
                  v-model="qualificationForm.identityCardNo"
                  placeholder="请填写法人身份证号"
                  class="demo-ruleForm-input"
                  maxlength="45"
                ></el-input>
              </el-form-item>
              <el-form-item label="注册地">
                <div class="demo-ruleForm-box">
                  <el-select
                    v-model="regAddress.provincesId"
                    placeholder="请选择"
                    @change="handleRegionsDataChange"
                    class="demo-ruleForm-half-select"
                  >
                    <el-option
                      v-for="item in regionsData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="regAddress.regionId"
                    placeholder="请选择"
                    class="demo-ruleForm-half-select"
                  >
                    <el-option
                      v-for="item in regionsDataChild"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div class="remark-tip">请与资质照片上的注册地保持一致。若下拉列表中无该注册地城市，请联系销售或运营</div>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="个人姓名">
                <el-input
                  v-noSpace
                  v-model="qualificationForm.partnerName"
                  placeholder="请填写个人姓名"
                  class="demo-ruleForm-input"
                  maxlength="45"
                />
              </el-form-item>
              <el-form-item label="证件类型">
                <div class="demo-ruleForm-box">
                  <el-select
                    v-model="qualificationForm.licenseType"
                    placeholder="请选择"
                    class="demo-ruleForm-select"
                  >
                    <el-option label="身份证号" :value="0"></el-option>
                    <el-option label="护照号" :value="1"></el-option>
                    <el-option label="个人港澳/台湾居民往来大陆通行证证号" :value="2"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="证件照片" class="avatar-uploader-me">
                <div class="demo-ruleForm-box">
                  <Upload
                    :uploadUrl="uploadImgUrl"
                    class="avatar-uploader"
                     accept=".jpeg, .png"
                    @handleAvatarSuccess="handleIdentitySuccess"
                    :beforeAvatarUpload='handleBeforeAvatarUpload'
                  >
                    <template slot="upload-icon">
                  <img  v-if="qualificationForm.identityCardFront !== ''"
                      :src="qualificationForm.identityCardFront" class="avatar" />
                       <span v-else>
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                      <div class="text-title">身份证正面</div>
                    </span>
                    </template>
                  </Upload>
                  <Upload
                    :uploadUrl="uploadImgUrl"
                    class="avatar-uploader"
                     accept=".jpeg, .png"
                    @handleAvatarSuccess="handleCardContrarySuccess"
                    :beforeAvatarUpload='handleBeforeAvatarUpload'
                  >
                      <template slot="upload-icon">
                        <img  v-if="qualificationForm.identityCardContrary !== ''"
                      :src="qualificationForm.identityCardContrary" class="avatar" />
                       <span v-else>
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                      <div class="text-title">身份证反面</div>
                    </span>
                      </template>
                  </Upload>
                  <Upload
                    :uploadUrl="uploadImgUrl"
                    class="avatar-uploader"
                     accept=".jpeg, .png"
                     @handleAvatarSuccess="handleLicenseSuccess"
                    :beforeAvatarUpload='handleBeforeAvatarUpload'
                  >
                      <template slot="upload-icon">
                        <img  v-if="qualificationForm.license !== ''"
                      :src="qualificationForm.license" class="avatar" />
                       <span v-else>
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                      <div class="text-title">手持身份证照</div>
                    </span>
                      </template>
                  </Upload>
                </div>
                <div class="remark-tip">仅持jpeg、png格式图片，且单张大小不能大于5M</div>
              </el-form-item>
              <el-form-item label="证件编号" prop="qualificationCode">
                <el-input
                  v-noSpace
                  v-model="qualificationForm.identityCardNo"
                  placeholder="请先选择证件类型，再填写资质编号"
                  class="demo-ruleForm-input"
                />
                <div class="remark-tip">请确保所填身份证编号与身份证照片上的一致</div>
              </el-form-item>
              <el-form-item label="证件有效期">
                 <div class="demo-ruleForm-box">
               <el-select v-model="qualificationForm.licenseUsefulLifeType" placeholder="请选择" :class=" qualificationForm.licenseUsefulLifeType === 0 ? 'demo-ruleForm-half-select' : 'demo-ruleForm-select'">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <template v-if="qualificationForm.licenseUsefulLifeType ===0">
                <el-date-picker
                  v-model="qualificationForm.licenseUsefulLifeTime"
                  class="demo-ruleForm-half-picker"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
                </template>
                 </div>
                <div class="remark-tip">请与身份证照片上的有效期保持一致，若为长期有效证件请选择“无截止日期”</div>
              </el-form-item>
            </template>
            <div class="step-action">
              <el-form-item>
                <div class="demo-ruleForm-box">
                    <div class="demo-ruleForm-btn">
                    <el-button type="primary" @click="handleSaveInfo('qualificationForm',2)">下一步</el-button>
                  </div>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div v-show="stepActive === 3">
        <div class="account-form--wrapper">
          <div class="step-to-loging">
            <p>
              <i class="el-icon-circle-check"></i>已完成注册，
              <span>{{logTime}}</span> 秒后自动进入登录页面 . . .
            </p>
            <el-button type="primary" class="demo-ruleForm-btn" @click="handleToLoging">立即登录</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import SiteName from '@/components/SiteName'
import loginMixin from './loginMixin.js'
import Upload from '@/components/Upload'
export default {
  mixins: [loginMixin],
  components: {
    SiteName,
    Upload
  },
  data() {
    var validatorPhone = (rule, value, callback) => {
      if (value === '') {
        this.checkPhoneAndCode.phoneDisabled = false
        callback(new Error('请填写手机号'))
      } else {
        const regx = /^1(3|4|5|7|8)\d{9}$/
        if (!regx.test(value)) {
          this.checkPhoneAndCode.phoneDisabled = false
          callback(new Error('请输入正确手机号'))
        } else {
          this.$service.checkRegister({ emailOrPhone: this.$encrypt(value), flag: 0 }).then(data => {
            if (data.data === false) {
              this.checkPhoneAndCode.phoneDisabled = true
              callback()
            } else {
              this.checkPhoneAndCode.phoneDisabled = false
              callback(new Error('该手机已注册，请直接登录'))
            }
          })
        }
      }
    }
    var validatorCode = (rule, value, callback) => {
      if (value === '') {
        this.checkPhoneAndCode.codeDisabled = false
        callback(new Error('请填写验证码'))
      } else {
        if (value.length < 4) {
          this.checkPhoneAndCode.codeDisabled = false
          callback(new Error('验证码输入有误'))
        } else {
          this.$service.checkCode({ code: value }).then(data => {
            if (data.isError) {
              this.checkPhoneAndCode.codeDisabled = false
              callback(new Error('验证码输入有误'))
            } else {
              this.checkPhoneAndCode.codeDisabled = true
              callback()
            }
          })
        }
      }
    }
    var validtorPhoneCode = (rule, value, callback) => {
      if (value === '') {
        this.nextBtnDisabled = true
        callback(new Error('请填写验证码'))
      } else {
        this.$service
          .checkSmsCode({
            code: value,
            emailOrPhone: this.$encrypt(this.basicForm.phone)
          })
          .then(data => {
            if (data.isError) {
              this.nextBtnDisabled = true
              callback(new Error('请输入正确短信验证码'))
            } else {
              callback()
              this.nextBtnDisabled = false
            }
          })
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (/^(?![A-Za-z0-9]+$)(?![A-Za-z\W]+$)(?![0-9\W]+$)[a-zA-Z0-9\W]{8,}$/.test(value)) {
          if (this.accountForm.confirmPassword !== '') {
            this.$refs.accountForm.validateField('confirmPassword')
          }
          callback()
        } else {
          callback(new Error('必须包含数字、字母及特殊符号，长度不少于8位'))
        }
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.accountForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      stepActive: 0,
      basicForm: {
        phone: '',
        code: '',
        phoneCode: '',
        // acceptChecked: [],
        step: 1
      },
      basicFormRules: {
        phone: [{ required: true, validator: validatorPhone, trigger: 'blur' }],
        code: [{ required: true, validator: validatorCode, trigger: 'blur' }],
        phoneCode: [
          { required: true, validator: validtorPhoneCode, trigger: 'blur' }
        ]
        // acceptChecked: [
        //   {
        //     type: 'array',
        //     required: true,
        //     message: '请勾选协议',
        //     trigger: 'change'
        //   }
        // ]
      },
      // isStepTwo: true,
      logTime: 5,
      accountForm: {
        // province: '',
        // city: '',
        partnerName: '',
        contact: '',
        firstIndustry: '',
        secondIndustry: '',
        // email: '',
        password: '',
        confirmPassword: '',
        step: 2 // 注册步骤
        // phoneCode: '' // 邮箱验证码
      },
      accountFormRules: {
        partnerName: [
          { required: true, message: '请填写公司名称', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请填写联系人姓名', trigger: 'blur' }
        ],
        firstIndustry: [
          { required: true, message: '请选择一级行业', trigger: 'change' }
        ],
        secondIndustry: [
          { required: true, message: '请选择二级行业', trigger: 'change' }
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
      qualificationForm: {
        registerType: 0,
        partnerName: '',
        companyNature: '',
        licenseType: '',
        license: '', // 资质图片或手持图片
        licenseSn: '', // 编号
        licenseUsefulLifeTime: undefined, // 有效期
        licenseUsefulLifeType: 0,
        legalPerson: '', // 法人/经营者
        identityCardFront: '', // 证件照正面
        identityCardContrary: '', // 证件照反面
        identityCardNo: '', // 身份证号
        registeredAddress: '', // 注册地址
        step: 3
      },
      options: [
        {
          value: 0,
          label: '有效期至'
        }, {
          value: 1,
          label: '长期有效'
        }
      ],
      regAddress: {
        provincesId: '',
        regionId: ''
      },
      qualificationFormRules: {},
      // 交互验证码
      checkPhoneAndCode: {
        codeDisabled: false,
        phoneDisabled: false
      },
      phoneCode: {
        codeCount: 120,
        msg: '发送验证码',
        timer: null
      },
      emailCode: {
        codeCount: 180,
        msg: '发送验证码',
        timer: null,
        disabled: true
      },
      codePicUrl: 'api/captcha.jpg',
      uploadImgUrl: 'api/dsp/adDspPartner/uploadFile',
      regionsData: [],
      regionsDataTwoChild: [],
      regionsDataChild: [],
      nextBtnDisabled: true
    }
  },
  computed: {
    phoneMsgDisabled() {
      let disabled = true
      if (this.checkPhoneAndCode.phoneDisabled && this.checkPhoneAndCode.codeDisabled) {
        if (this.phoneCode.msg.indexOf('已发送') > -1) {
          disabled = true
        } else {
          disabled = false
        }
      }
      return disabled
    },
    nexbtnDisabled() {
      let disabled = true
      const status = []
      for (let i in this.accountForm) {
        if (this.accountForm[i]) {
        } else {
          status.push(0)
        }
      }
      if (status.length === 0) {
        this.$refs.accountForm.validate(valid => {
          if (valid) {
            disabled = false
          }
        })
      }
      return disabled
    }
  },
  methods: {
    genInteractionCodeMethods(typeCode, type) {
      let count = typeCode.codeCount
      typeCode.msg = '已发送(' + count + ')'
      typeCode.disabled = true
      this.$service.sendCode({
        phone: type === 'phone' ? this.$encrypt(this.basicForm.phone) : undefined
      })
      let timeFun = () => {
        count--
        typeCode.msg = '已发送(' + count + ')'
        if (count <= 0) {
          typeCode.disabled = false
          typeCode.msg = '重新发送'
          clearInterval(timeIn)
        }
      }
      let timeIn = setInterval(() => {
        timeFun()
      }, 1000)
    },
    handleSaveInfo(formName, val) {
      let params = {}
      if (val === 1) { // 填写基本信息
        this.$refs[formName].validate(valid => {
          if (valid) {
            params = this.cloneDeep(this.accountForm)
            params.phone = this.$encrypt(this.basicForm.phone)
            params.password = this.$encrypt(this.accountForm.password)
            params.confirmPassword = this.$encrypt(this.accountForm.confirmPassword)
            this.$service.registerSave(params).then(data => {
              this.stepActive++
            })
          }
        })
      } else { // 补全广告资质
        params = this.cloneDeep(this.qualificationForm)
        params.phone = this.$encrypt(this.basicForm.phone)
        params.identityCardNo = this.$encrypt(this.qualificationForm.identityCardNo)
        params.registeredAddress = this.regAddress.provincesId + ',' + this.regAddress.regionId
        this.$service.registerSave(params).then(data => {
          if (data.code === 0) {
            this.stepActive++
            this.goToLoging()
          }
        })
      }
    },
    goToLoging() {
      let count = this.logTime
      let timeFun = () => {
        count--
        this.logTime = count
        if (count <= 0) {
          this.handleToLoging()
          clearInterval(timeIn)
        }
      }
      let timeIn = setInterval(() => {
        timeFun()
      }, 1000)
    },
    handleToLoging() {
      this.$router.push({
        name: 'login'
      })
    },
    handleClickFirstNext(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = this.cloneDeep(this.basicForm)
          // delete params.acceptChecked
          params.phone = this.$encrypt(params.phone)
          this.$service.registerSave(params).then(data => {
            if (data.code === 0) {
              this.stepActive++
            }
          })
        }
      })
    },
    updateValicode() {
      this.codePicUrl += '?_=' + new Date().getTime()
    },
    handleBeforeAvatarUpload(file, fileType) {
      const suffix = file.name.split('.').slice(-1)[0]
      const extension = suffix === 'jpg'
      const extension2 = suffix === 'jpeg'
      const extension3 = suffix === 'png'
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!extension && !extension2 && !extension3) {
        this.$message.error('上传图片格式必须为jpg/jpeg/png格式')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return (extension || extension2 || extension3) && isLt2M
    },
    handleLicenseSuccess(res, file) {
      if (res.code === 0) {
        this.qualificationForm.license = res.data.mediaIcon
      }
    },
    handleIdentitySuccess(res, file) {
      if (res.code === 0) {
        this.qualificationForm.identityCardFront = res.data.mediaIcon
      }
    },
    handleCardContrarySuccess(res, file) {
      if (res.code === 0) {
        this.qualificationForm.identityCardContrary = res.data.mediaIcon
      }
    },
    getRegionList() {
      this.loading = true
      this.$service
        .getRegistRegionList({})
        .then(data => {
          const areaData = data.slice().filter(item => {
            return item.name !== '未匹配'
          })
          areaData.forEach(item => {
            if (item.parent === 0) {
              this.regionsData.push({
                value: item.regionId,
                label: item.name,
                children: []
              })
            }
          })
          for (let i = 0; i < this.regionsData.length; i++) {
            for (let j = 0; j < areaData.length; j++) {
              if (areaData[j].parent === this.regionsData[i].value) {
                this.regionsData[i].children.push({
                  value: areaData[j].regionId,
                  label: areaData[j].name
                })
              }
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleRegionsDataTwoChange() {
      const regData = this.regionsData
      for (let i = 0; i < regData.length; i++) {
        if (regData[i].value === this.accountForm.province) {
          this.regionsDataTwoChild = regData[i].children
          break
        }
      }
    },
    handleRegionsDataChange() {
      const regData = this.regionsData
      for (let i = 0; i < regData.length; i++) {
        if (regData[i].value === this.regAddress.provincesId) {
          this.regionsDataChild = regData[i].children
          break
        }
      }
    }
  },
  created() {
    this.updateValicode()
    this.getRegionList()
  }
}
</script>
<style lang="stylus" scoped>
.header-button-text {
  color: #fff;
  font-size: 14px;
}

.content-steps {
  width: 828px;
  margin: 0 auto;
}

.content-step >>> .el-step__head .el-step__icon.is-text {
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: rgba(0, 0, 0, 0.15);
}

.content-step >>> .el-step__icon {
  width: 32px;
  height: 32px;
}

.content-step >>> .el-step__icon-inner {
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.25);
  line-height: 22px;
}

.content-step >>>.el-step__line {
  height: 2px;
  background: rgba(0, 0, 0, 0.15);
  top: 50%;
}

.content-step >>>.el-step__title {
  font-size: 14px;
  height: 34px;
  line-height: 34px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.2);
}

.content-step >>> .el-step__head.is-process {
  .el-step__icon.is-text {
    background-color: #ff8b00;
    border-color: #ff8b00;
  }

  .el-step__icon-inner {
    color: #fff;
  }
}

.content-step >>>.el-step__title.is-process {
  color: #ff8b00;
}

.half-item--right {
  float: right;
}

.content-step >>> .el-step__head.is-success {
  border-color: #ff8b00;

  .el-step__icon.is-text {
    border-color: #ff8b00;
  }

  .el-step__line {
    background-color: #ff8b00;
  }

  .el-step__icon-inner {
    color: #ff8b00;
  }

  .el-step__line .el-step__line-inner {
  }
}

.icon-header {
  display: flex;
  flex-direction: row;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.third-item--less > >>>.el-button {
  width: 107px;
  padding: 10px;
  margin-left: 5px;
}

.pic-code--wrapper {
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  width: 107px;
  margin-left: 5px;
}

.pic-code--wrapper img {
  max-width: 100%;
  padding-top: 2px;
}

.content-title {
  text-align: center;
  height: 33px;
  font-size: 24px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  line-height: 33px;
  margin: 40px 0;
}

.account-form--wrapper {
  // width: 700px;
  margin: 0 auto;
  margin-top: 40px;
}

.demo-ruleForm {
  margin: 0 auto;
  width: 507px;
}

.form-box-item, .demo-ruleForm-box {
  display: flex;
  flex-direction: row;
}

.demo-ruleForm-input, .demo-ruleForm-btn, .demo-ruleForm-select, .demo-ruleForm-picker {
  width: 411px;
}
.demo-ruleForm-btn >>>.el-button {
  width:100%
}

>>>.el-radio-button__inner {
  width: 104px;
}

.demo-ruleForm-half-select, .demo-ruleForm-half-picker {
  width: 203px;
}
.demo-ruleForm-box .demo-ruleForm-half-select:nth-child(1), .demo-ruleForm-box .avatar-uploader-card>>>.el-upload:nth-child(1), .demo-ruleForm-box .avatar-uploader-front-img >>>.el-upload:nth-child(1), .demo-ruleForm-box .avatar-uploader-front-img >>>.el-upload:nth-child(2) {
  margin-right: 5px;
}

.demo-ruleForm-input-code {
  width: 297px;
}

.demo-ruleForm-short-btn {
  width: 104px;
}

.demo-ruleForm-long-btn {
  width: 302px;
  margin-left: 5px;
}

.demo-ruleForm-short-btn .el-button, .demo-ruleForm-long-btn .el-button {
  width: 100%;
}

.remark-tip {
  // min-width: 317px;
  height: 22px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  // padding-left 8px
}

.text-title {
  color: rgba(0, 0, 0, 0.65);
  font-size: 12px;
  height: 22px;
  line-height: 22px;
}

.text-tip {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  height: 16px;
  line-height: 16px;
}

>>>.avatar-uploader-icon {
  font-size: 24px;
  margin-top: 24px;
  color: rgba(0, 0, 0, 0.45);
}
.avatar {
  max-width 100%
}

.avatar-uploader-card .text-wrapper {
  text-align: center;
}

.demo-ruleForm-box .avatar-uploader {
  width: 102px;
  height: 102px;
}

.demo-ruleForm-box .avatar-uploader-card>>>.el-upload {
  width: 102px;
  height: 102px;
}

.demo-ruleForm-box .avatar-uploader {
  margin-right: 16px;
}

.step-to-loging {
  text-align: center;
}
</style>
